import clsx from 'clsx';
import * as React from 'react';
import FilterStore from './Store';
import Dropdown from './Dropdown';
import { observer } from 'mobx-react';
import { FilterOptions } from './Types';
import { Menu } from '@headlessui/react';
import FilterButtonText from './FilterButtonText';
import { when } from '@execonline-inc/maybe-adapter';
import { TPlainTextKey } from '../../../../../../../Translations';

interface Props {
  filterStore: FilterStore;
  options: FilterOptions[];
  filterName: TPlainTextKey;
  zIndex: string;
}

const FilterTemplate: React.FC<Props> = ({ filterStore, options, filterName, zIndex }) => (
  <div className={`${zIndex} flex md:flex-row`}>
    <div className="mr-6">
      <Menu as="div">
        {({ open }) => (
          <>
            <Menu.Button
              onClick={() => when(open, {}).do(filterStore.close).elseDo(filterStore.open)}
              className={clsx(
                'mt-1 block w-fit rounded-md border-1 border-solid',
                'border-gray-300 bg-white px-3 py-2 text-sm font-medium',
              )}
            >
              <FilterButtonText filterStore={filterStore} filterName={filterName} />
            </Menu.Button>
            {when(open, {})
              .map(() => <Dropdown filterStore={filterStore} options={options} />)
              .getOrElse(() => (
                <></>
              ))}
          </>
        )}
      </Menu>
    </div>
  </div>
);

export default observer(FilterTemplate);
